export const calculateCompoundInterest = (
    principal,
    rate,
    time,
    monthlyDeposit,
    depositFeePercent = 0,
    accrualFeePercent = 0,
    tax = 0
) => {
    const compoundingFrequency = 12;
    const monthlyInterestRate = rate / 100 / compoundingFrequency;
    const totalCompoundingPeriods = time * compoundingFrequency;
    const totalDeposits = monthlyDeposit * time * compoundingFrequency + principal;
    const depositWithFee = monthlyDeposit - (depositFeePercent / 100) * monthlyDeposit;
    let compoundInterest = principal;
    let compoundInterestWithoutFees = principal;
    let totalEarnings = 0;
    let totalManagementFeesFromDeposit = 0;
    let totalManagementFeesFromAccrual = 0;
    let lostProfitsFromFees = 0;
    let accumulatedCompoundOfDepositFees = 0;
    let accumulatedCompoundOfAccrualFees = 0;

    // iterate over the compounding periods
    for (let i = 0; i < totalCompoundingPeriods; i++) {
        // calculate the interest with and without fees
        // const interest = compoundInterest * (monthlyInterestRate - accrualFeePercent / 100 / compoundingFrequency);
        const interest = compoundInterest * monthlyInterestRate;
        const interestWithoutFees = compoundInterestWithoutFees * monthlyInterestRate;

        // update the principal with and without fees
        compoundInterest += interest + depositWithFee;
        compoundInterestWithoutFees += interestWithoutFees + depositWithFee;

        // update the earnings with and without fees
        totalEarnings += interest;

        // update the fees from the deposit and the accrual
        if (depositFeePercent > 0) {
            totalManagementFeesFromDeposit += monthlyDeposit * (depositFeePercent / 100);
            // accumulatedCompoundOfDepositFees += totalManagementFeesFromDeposit * rate / 100;
            accumulatedCompoundOfDepositFees += totalManagementFeesFromDeposit * rate / 100 / compoundingFrequency;
            // console.log('totalManagementFeesFromDeposit:', totalManagementFeesFromDeposit)
            // console.log(totalManagementFeesFromDeposit * (1 + (monthlyInterestRate / 100 / compoundingFrequency)));
        }
        if (accrualFeePercent > 0) {
            totalManagementFeesFromAccrual += compoundInterest * (accrualFeePercent / 100 / compoundingFrequency);
            accumulatedCompoundOfAccrualFees += totalManagementFeesFromAccrual * rate / 100 / compoundingFrequency;
            // console.log('totalManagementFeesFromAccrual:', totalManagementFeesFromAccrual)
        }
    }
    // console.log('accumulatedCompoundOfDepositFees:', accumulatedCompoundOfDepositFees)
    // console.log('accumulatedCompoundOfAccrualFees:', accumulatedCompoundOfAccrualFees)
    // calculate the loss of profit due to fees
    // lostProfitsFromFees = totalManagementFeesFromDeposit + totalManagementFeesFromAccrual;

    // const test = lostProfitsFromFees * Math.pow(1 + (monthlyInterestRate - 0 / 100 / 12), totalCompoundingPeriods) +
    // 0 *
    //     ((Math.pow(1 + (monthlyInterestRate - 0 / 100 / 12), totalCompoundingPeriods) - 1) /
    //         (monthlyInterestRate - 0 / 100 / 12));
    // lostProfitsFromFees = (totalManagementFeesFromDeposit + totalManagementFeesFromAccrual) * Math.pow(1 + monthlyInterestRate, totalCompoundingPeriods) + 0 * ((Math.pow(1 + monthlyInterestRate, totalCompoundingPeriods) - 1) / monthlyInterestRate);
    lostProfitsFromFees = accumulatedCompoundOfDepositFees + accumulatedCompoundOfAccrualFees;

    // console.log('totalManagementFeesFromDeposit:', totalManagementFeesFromDeposit)
    // console.log('totalManagementFeesFromAccrual:', totalManagementFeesFromAccrual)
    // console.log('totalEarnings:', totalEarnings)
    // console.log('compoundInterest:', compoundInterest)
    compoundInterest = compoundInterest - totalManagementFeesFromDeposit - totalManagementFeesFromAccrual - lostProfitsFromFees;
    totalEarnings = totalEarnings - totalManagementFeesFromDeposit - totalManagementFeesFromAccrual - lostProfitsFromFees;
    
    // apply the tax to the final amount and the earnings
    if (totalEarnings !== Infinity) {
        compoundInterest -= totalEarnings * tax;
        totalEarnings -= totalEarnings * tax;
    }

    // console.log("compoundInterest:", compoundInterest.toFixed(2));
    // console.log("totalDeposits:", totalDeposits.toFixed(2));
    // console.log("totalManagementFeesFromDeposit:", totalManagementFeesFromDeposit.toFixed(2));
    // console.log("totalManagementFeesFromAccrual:", totalManagementFeesFromAccrual.toFixed(2));
    // console.log("totalEarnings:", totalEarnings.toFixed(2));
    // console.log("lostProfitsFromFees:", lostProfitsFromFees.toFixed(2));
    // return the results as an object
    return {
        compoundInterest: compoundInterest.toFixed(2),
        totalDeposits: totalDeposits.toFixed(2),
        totalManagementFeesFromDeposit: totalManagementFeesFromDeposit.toFixed(2),
        totalManagementFeesFromAccrual: totalManagementFeesFromAccrual.toFixed(2),
        totalEarnings: totalEarnings.toFixed(2),
        lostProfitsFromFees: lostProfitsFromFees.toFixed(2),
    };
};

// export const calculateFVAfterTax = (futureValue, profit, tax) => {
//     if (futureValue === Infinity || profit === Infinity || tax === Infinity) return Infinity;

//     let profitAfterTax = profit - profit * tax;
//     const futureValueAfterTax = futureValue - profit + profitAfterTax;

//     if (!futureValueAfterTax || futureValueAfterTax < 0) profit = 0;
//     if (futureValueAfterTax % 1 === 0) return futureValueAfterTax;
//     else return parseFloat(futureValueAfterTax.toFixed(2));
// };
